<template>
    <div class="page have-menu">
        <TopBar></TopBar>
        <div class="pt-4">
            <DashboardCategorySlider
                :apiConfig="dashboardConfig"
                @clickTab="onSelectCat($event)"
                @onLoaded="onLoadSuccess('dashboard')">
            </DashboardCategorySlider>
        </div>
        <div class="px-4" v-if="isInitialCampaign">
            <CampaignList
                    v-if="campaignListConfig != null && campaignListFilter != null && selectedCat.line1 != 'Favorite'"
                    ref="campaign-list"
                    :initListConfig="campaignListConfig"
                    :initFilterConfig="campaignListFilter"
                    :modalController="modalController"
                    @onLoaded="onLoadSuccess('campaign')"
            ></CampaignList>
            <CampaignFavoriteList
                    v-if="selectedCat.line1 == 'Favorite'"
                    ref="campaign-list"
                    :initListConfig="campaignListConfig"
                    :initFilterConfig="campaignListFilter"
                    :modalController="modalController"
            ></CampaignFavoriteList>
        </div>
        <MenuBar
            :modalController="modalController"
        ></MenuBar>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
import Locale from "@/helper/locale/Locale.js";
import ConfigManager from "@/config/ConfigManager.js";
import CacheHelper from "@/helper/CacheHelper.js";
// component
import TopBar from "@/components/Layout/TopBar/TopBar.vue";
import DashboardCategorySlider from "@/components/Dashboard/DashboardCategorySlider.vue";
import CampaignList from "@/module/List/component/CampaignList/CampaignList.vue";
import CampaignFavoriteList from "@/module/List/component/CampaignList/CampaignFavoriteList.vue";
import MenuBar from "@/components/Layout/MenuBar/MenuBar.vue";
// service
import {
    CampaignListConfigBuilder,
    CampaignListFilterConfigBuilder
} from "@/core/Campaign/config/CampaignConfigModel.js";
import { FlashSaleConfigBuilder } from "@/core/Campaign/config/DashboardConfigModel.js";
import BzbsDashboard from "@/core/Campaign/service/BzbsDashboard.js";
// mixin
import AuthStatusMixin from "@/mixin/AuthStatusMixin.js";
import ModalMixin from "@/mixin/ModalMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import AuthPageMixin from "@/mixin/AuthPageMixin";

export default {
    name: "Home",
    mixins: [ModalMixin, LocaleMixin, AuthStatusMixin, AuthPageMixin],
    components: {
        TopBar,
        DashboardCategorySlider,
        CampaignList,
        CampaignFavoriteList,
        MenuBar
    },
    data: function() {
        return {
            dashboardConfig: ConfigManager.getDashboardConfig().mainDashboard,
            campaignListConfig: null,
            campaignListFilter: null,
            isInitialCampaign: false,
            arrDashboard: [],

            loadingStatus: {
                dashboard: false,
            },
        };
    },
    created: function() {
        this.setScrollLoadMore();

        // this.tracking.screenName('home');
        // this.tracking.event('home', 'view_home');
    },
    mounted: function() {
        this.loadingModal.show();
        this.handleFlashSaleModal();
    },
    beforeUnmount: function() {
        window.onscroll = null;
    },
    methods: {
        onAccountInit: function() {
            if (this.isLogin) {
                this.tracking.screenName('home');
                this.tracking.event('home', 'view_home');
            }
        },
        onSetupModalCompleted: function() {
            this.initialFlashSaleModal();
        },
        handleFlashSaleModal: function () {
            let cacheHelper = new CacheHelper("session");
            let dashboardFlashSale = cacheHelper.getCache('dashboard_flashsale');
            if (dashboardFlashSale && dashboardFlashSale.isshow) {
                console.log("arrDashboard", this.arrDashboard);
                this.flashSaleModal.show();
                cacheHelper.setCache('dashboard_flashsale', {isshow : false});
            }
        },
        setScrollLoadMore: function() {
            window.onscroll = () => {
                // 100 คือระยะก่อนถึงจุดล่างสุดของ page
                let scrollOffSet = 100;
                let pageHeight = Math.max(
                    window.scrollY,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                let bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;
                if (bottomOfWindow) {
                    this.loadMore();
                }
            };
        },
        setCampaignList: function() {
            this.campaignListConfig = null;
            this.campaignListFilter = null;

            let listConfig = new CampaignListConfigBuilder()
                            .setConfigList(this.selectedCat.hashtag_list_config)
                            .setTop(25);
            if (this.selectedCat.cat) {
                listConfig.setCatId(this.selectedCat.cat);
            }
            this.campaignListConfig = listConfig.create();

            let filterConfig = null;
            if (this.selectedCat.cat) {
                filterConfig = new CampaignListFilterConfigBuilder()
            } else {
                if (this.profile.updated_points.points == 0) {
                    filterConfig = new CampaignListFilterConfigBuilder()
                }
                if (this.selectedCat.line1 != 'Favorite') {
                    filterConfig = new CampaignListFilterConfigBuilder()
                                .setMinPoint(0)
                                .setMaxPoint(this.profile.updated_points.points)
                                .strSortby("points_desc");
                } else {
                    filterConfig = new CampaignListFilterConfigBuilder()
                }
            }

            this.campaignListFilter = filterConfig.create();
        },

        loadMore: function() {
            if(this.isInitialCampaign) {
                if(this.selectedCat.line1 != 'Favorite'){
                    this.$refs['campaign-list'].loadMore();
                }
            }
        },

        onSelectCat: function(data) {
            this.tracking.event('home_category', 'click_category', data.cat.cat + '|' + data.cat.line1);

            this.selectedCat = data.cat;
            this.setCampaignList();

            if (this.isInitialCampaign) {
                this.$refs['campaign-list'].reinitList(this.campaignListConfig, this.campaignListFilter);
            } else {
                this.isInitialCampaign = true;
            }
        },

        onLoadSuccess: function(api) {
            if (!this.loadingStatus[api]) {
                this.loadingStatus[api] = true;
                let found = false;
                for (let i in this.loadingStatus) {
                    if (!this.loadingStatus[i]) {
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    this.loadingModal.hide();
                }
            }
        },
        getFlashSale: function() {
            let configBuilder = new FlashSaleConfigBuilder();
            configBuilder.setLocale(Locale.getLocaleCode());
            let flashSale = ConfigManager.getDashboardConfig().flashsale;
            let params = configBuilder.create().getParams();
            BzbsDashboard.apiGetSubDashboard(params, flashSale).subscribe((data) => {
                this.arrDashboard = data;
                this.flashSaleModal.show();
                console.log(this.arrDashboard);
                this.$emit('onLoaded');
            }, (err) => {
                this.$emit('onLoaded');
                console.log(err);
            });
        },
    },
}
</script>
